import React from 'react';

import Conditional from '../../common/conditional';
import Loader from '../loader';

import classNames from './autocomplete.module.scss';

interface AutoCompleteProps {
	data: string[];
	geocoding: boolean;
	onSelect: (item: string) => void;
	onCancel: () => void;
}

const AutoComplete: React.FC<AutoCompleteProps> = (props) => {
	return (
		<Conditional isVisible={props.data.length > 0}>
			<React.Fragment>
				<Loader isVisible={props.geocoding} />

				<Conditional isVisible={!props.geocoding}>
					<div className="d-flex justify-content-end">
						<button
							className={classNames['list-option-close']}
							onClick={props.onCancel}
						>
							<span>Close</span>
						</button>
					</div>

					<div className={classNames['list-option']}>
						{props.data.map((item: string, index: number) => (
							<button
								key={index}
								className={classNames['list-option-item']}
								onClick={() => props.onSelect(item)}
							>
								<i className="bi bi-list-nested"></i>
								<span>{item}</span>
							</button>
						))}
					</div>
				</Conditional>
			</React.Fragment>
		</Conditional>
	);
};

export default AutoComplete;
